// extracted by mini-css-extract-plugin
export default {"stream":"VLc1H","gift":"req6g","giftIcon":"qV3PI","price":"L2qIC","desktop":"fWoLX","chat":"tPHko"};